// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Global Dark Mode Consistency
 * Uses CSS variables defined in dark-mode.css.
 * AVOID !important -- component styles should naturally use CSS vars.
 * Only override here when Bootstrap/third-party hardcodes colors.
 */

/* Base body transition */
body {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Default link color */
a {
  color: var(--accent-primary);
}

/* Make sure the .App container inherits the theme */
.App {
  background: var(--bg-primary);
  color: var(--text-primary);
  min-height: 100vh;
}

/* Ensure form elements pick up theme in dark mode */
.dark input,
.dark textarea,
.dark select {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border-color: var(--border-primary);
}

.dark input::placeholder,
.dark textarea::placeholder {
  color: var(--text-tertiary);
}

/* Scrollbar for dark mode */
.dark ::-webkit-scrollbar-track {
  background: var(--bg-secondary);
}

.dark ::-webkit-scrollbar-thumb {
  background: var(--border-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/global-dark-mode.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,yBAAyB;AACzB;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA,uBAAuB;AACvB;EACE,4BAA4B;AAC9B;;AAEA,oDAAoD;AACpD;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;;;EAGE,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/*\r\n * Global Dark Mode Consistency\r\n * Uses CSS variables defined in dark-mode.css.\r\n * AVOID !important -- component styles should naturally use CSS vars.\r\n * Only override here when Bootstrap/third-party hardcodes colors.\r\n */\r\n\r\n/* Base body transition */\r\nbody {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n/* Default link color */\r\na {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n/* Make sure the .App container inherits the theme */\r\n.App {\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Ensure form elements pick up theme in dark mode */\r\n.dark input,\r\n.dark textarea,\r\n.dark select {\r\n  background-color: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  border-color: var(--border-primary);\r\n}\r\n\r\n.dark input::placeholder,\r\n.dark textarea::placeholder {\r\n  color: var(--text-tertiary);\r\n}\r\n\r\n/* Scrollbar for dark mode */\r\n.dark ::-webkit-scrollbar-track {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.dark ::-webkit-scrollbar-thumb {\r\n  background: var(--border-secondary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
